export const stripTags = (value: string): string =>
    value.replace(/(<([^>]+)>)/gi, '');

export function highlightText(
    text: string,
    startTag = '{% highlight %}',
    endTag = '{% endhighlight %}',
    startReplacement = '<mark>',
    endReplacement = '</mark>'
): string {
    const regex = new RegExp(`${startTag}(.*?)${endTag}`, 'g');
    const splitText = [];
    let lastIndex = 0;

    text.replace(regex, (match, innerContent, offset) => {
        splitText.push(text.substring(lastIndex, offset));
        splitText.push(startReplacement + innerContent + endReplacement);
        lastIndex = offset + match.length;
        return match;
    });

    if (lastIndex < text.length) {
        splitText.push(text.substring(lastIndex));
    }

    return splitText.join('');
}
